// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const FiendSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'fiend-attack',
    metadata: {
      frames: {
        'fiend-attack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-attack-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-attack-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-attack-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/fiend/attack.png',
        size: {
          w: 1024,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'fiend-attack': [
          'fiend-attack-0',
          'fiend-attack-1',
          'fiend-attack-2',
          'fiend-attack-3',
        ],
      },
    },
  },
  {
    name: 'fiend-die',
    metadata: {
      frames: {
        'fiend-die-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-die-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-die-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-die-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-die-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-die-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/fiend/die.png',
        size: {
          w: 1536,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'fiend-die': [
          'fiend-die-0',
          'fiend-die-1',
          'fiend-die-2',
          'fiend-die-3',
          'fiend-die-4',
          'fiend-die-5',
        ],
      },
    },
  },
  {
    name: 'fiend-exhaust',
    metadata: {
      frames: {
        'fiend-exhaust-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-exhaust-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/fiend/exhaust.png',
        size: {
          w: 512,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'fiend-exhaust': ['fiend-exhaust-0', 'fiend-exhaust-1'],
      },
    },
  },
  {
    name: 'fiend-idle',
    metadata: {
      frames: {
        'fiend-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-idle-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-idle-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/fiend/idle.png',
        size: {
          w: 768,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'fiend-idle': ['fiend-idle-0', 'fiend-idle-1', 'fiend-idle-2'],
      },
    },
  },
  {
    name: 'fiend-run',
    metadata: {
      frames: {
        'fiend-run-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-run-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-run-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-run-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-run-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'fiend-run-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/fiend/run.png',
        size: {
          w: 1536,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'fiend-run': [
          'fiend-run-0',
          'fiend-run-1',
          'fiend-run-2',
          'fiend-run-3',
          'fiend-run-4',
          'fiend-run-5',
        ],
      },
    },
  },
];
